import React from 'react';
import { CalendarDaysIcon, ExternalLinkIcon } from 'lucide-react';
export function RegistrationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2430">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2431">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2432">
          <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-2433" />
          <div className="flex-1" data-id="element-2434">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2435">
              Check the club calendar for upcoming dates and times:
            </p>
            <a href="https://www.fentonlakes.com/m7/15--nra-personal-protection-outside-the-home-2-day-course.html" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2436">
              Click Here to Register
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-2437" />
        </div>
      </div>
    </div>;
}